module.exports = __webpack_public_path__ + "static/media/Basisschool.2d78ba1b.mp3";